import Accordion from "react-bootstrap/Accordion";
import "./Faq.css";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
export const FaqH1 = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: white;
  margin-bottom: 64px;
  text-align: center;

  span {
    color: #18e68e;
  }
`;

function Faq({ isRTL }) {
  const { t } = useTranslation();
  Faq.propTypes = {
    isRTL: PropTypes.bool.isRequired,
  };
  return (
    <div className="faq-container">
      <div className="faq-wrapper">
        <FaqH1>
          <span>{t("faq.title")}</span> {t("faq.title1")}
        </FaqH1>
        <Accordion
          className={`custom-accordion ${isRTL ? "rtl-accordion" : ""}`}
        >
          <Accordion.Item eventKey="0" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle1")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description1")}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle2")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description2")}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle3")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description3")}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle4")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description4")}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle5")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description5")}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="no-border">
            <Accordion.Header className={isRTL ? "rtl-header" : ""}>
              {t("faq.faqTitle6")}
            </Accordion.Header>
            <Accordion.Body className={isRTL ? "arabe" : ""}>
              {t("faq.description6")}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}

export default Faq;
